import _slicedToArray from "C:/Users/gilbe/OneDrive/Documents/GitHub/luth-main/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState } from 'react';
import { useIsomorphicEffect } from '../use-isomorphic-effect/use-isomorphic-effect.js';
import { randomId } from '../utils/random-id/random-id.js';

function useUuid(staticId) {
  var _useState = useState(""),
      _useState2 = _slicedToArray(_useState, 2),
      uuid = _useState2[0],
      setUuid = _useState2[1];

  useIsomorphicEffect(function () {
    setUuid(randomId());
  }, []);
  return staticId || uuid;
}

export { useUuid };